import { useEffect, useContext, useMemo } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import StateContext from "../../state/stateContext";
import { FeedCard } from "slide-ui";
import FeedIcon from "../Icons/FeedIcon";
import { dateTimeFormat, monthNameDateFormat } from '../../helpers/dateHelpers';
import { useInView } from 'react-intersection-observer';
import { handleCardView } from '../../helpers/analyticsHelpers';

export const FeedCardMSC = ({ index, id, className, isNew, title, icon, iconAlt, children, cardData, setDLData }) => {
  const { type, body } = cardData;
  const { state } = useContext(StateContext);
  const { childInfo } = state;

  const dateText = monthNameDateFormat(cardData.displayTime);
  const dateTime = dateTimeFormat(cardData.displayTime);
  const badgeContent = isNew ? <>New <FontAwesomeIcon icon={solid('star')} /></> : null;
  const badgeClassName = isNew ? "badge--new" : "";

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  const DLData = useMemo(() => {
    return {
      event: "feed_card_view",
      msc_card_position: `pos${index}`,
      msc_card_type: type,
      msc_card_title: title,
      msc_content_type: body?.typeCode || null,
      msc_content_subtype: body?.subTypeCode || null,
      msc_child_id: childInfo?.data?.identifier || null,
      msc_community_name: childInfo?.data?.projectName || null,
      msc_country_name: childInfo?.data?.countryName || null,
    }
  }, [index, body, childInfo, title, type]);

  useEffect(() => {
    if (setDLData) {
      setDLData(DLData);
    }
  }, [setDLData, DLData]);

  /**
   * {
    "event": "feed_card_view",
    "event_action": "msc_feed_card_impression",
    "event_category": `{content_type}_view`, 
    "event_label": {card_title}, 
    "msc_child_id": {child_id}, //required
    "msc_community_name": {community_name}, //required
    "msc_country_name": {country_name}, //required
    "msc_card_title": {card_title}, //required
    "msc_card_type": {card_type}, //required
    "msc_content_type": {content_type}, //conditional
    "msc_content_subtype": {content_subtype}, //conditional
    "msc_card_position": `pos{#}`, //required - pos1, pos2, pos3
    "ehash": {ehash}, 
    "non_interaction": true,
    "supporter_id": {supporter_id}, //required if logged in
}
   */

  useEffect(() => {
    if (inView) {
      handleCardView(DLData);
    }
  }, [DLData, inView]);

  return (
    <div ref={ref}>
      <FeedCard 
        id={id} 
        className={className}
        badgeClassName={badgeClassName}
        badgeContent={badgeContent}
      >
        <FeedCard.Header>
          <FeedCard.Title className="card--feed__title">{ title }</FeedCard.Title>
          <FeedCard.Icon className="card--feed__icon"><FeedIcon icon={icon} iconAlt={iconAlt} /></FeedCard.Icon>
          <FeedCard.Date className="card--feed__date"><time className="date-time" dateTime={dateTime}>{dateText}</time></FeedCard.Date>
        </FeedCard.Header>
        { children }
      </FeedCard>
    </div>
  );
}

export default FeedCardMSC;